import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_OLD, offerIncludes, offerRows } from '../data/edufis';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-223" data-mp="1hofnzt3dn96h">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-224" data-mp="tyv6zfqsalzu">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-225" data-mp="u0ocgrpnv069">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-226" data-mp="p120ellkjpz1">
            Scopri il tuo pacchetto completo <em className="text-red-300" data-id="element-227" data-mp="13yc6fffg03nd">EDUFIS PRONTO™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-228" data-mp="yx52jrgf7olz">
            Le tue lezioni di Educazione Fisica pronte in soli 5 minuti. Entra in palestra con tutto pronto.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-229" data-mp="2acblv14on74u" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-230" data-mp="pml89msvtjdb">
          <img src={PRODUCT_IMAGE} alt="EDUFIS PRONTO™: 6 volumi + 5 bonus" className="mx-auto mb-6 w-full max-w-[16rem] drop-shadow-xl lg:hidden" data-id="element-231" data-mp="zjg6s5p5njrl" />
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-232" data-mp="13hnnx1nj6n3b">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-233" data-mp="6rwgk1u555g3">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-234" data-mp="fufjelxxfi2c">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-235" data-mp="ft4eujwnq6a6">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-236" data-mp="kn8juxmd448m" />
                </span>
                <span data-id="element-237" data-mp="3oa7i4rse53ik">
                  <span className="block font-medium leading-snug" data-id="element-238" data-mp="3o9fnbj6mb9tc">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-239" data-mp="vf7dyi1mqicl">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-240" data-mp="qejq258p6hml">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-241" data-mp="105xm231fwzaz">
              Prezzo speciale <span className="ml-1 text-slate-900/50" data-id="element-242" data-mp="cgcy15qfjbuu">invece di <s data-id="element-243" data-mp="ch4vyn7i1loa">{PRICE_OLD}</s></span>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="7ibe6il6j8ib">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="lfgjuhgze5d1">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="hic26htzucsu" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Voglio il pacchetto completo" className="mt-8 w-full" data-id="element-247" data-mp="1svwco2va94hr" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="20ex800vxjru1">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="25es2eeewyzju">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}